/**
 * Scrolltrigger Animations Desktop + Mobile
 */
export function initScrolltriggerAnimations() {
  function getContrastClass(hex) {
    hex = hex.replace("#", "");

    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.58 ? "is-light" : "is-dark";
  }

  function initEmpanadasScroll() {
    const section = document.querySelector("#empanadas-home");
    const panels = gsap.utils.toArray("#empanadas-home .empanada-panel");

    if (!section || !panels.length) return;

    let currentColor = null;

    function getContrastClass(hex) {
      hex = hex.replace("#", "");

      if (hex.length === 3) {
        hex = hex
          .split("")
          .map((char) => char + char)
          .join("");
      }

      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      return luminance > 0.58 ? "is-light" : "is-dark";
    }

    function changeEmpanadaColor(color) {
      if (!color || color === currentColor) return;

      currentColor = color;

      section.classList.remove("is-light", "is-dark");
      section.classList.add(getContrastClass(color));

      gsap.to(section, {
        backgroundColor: color,
        duration: 0.7,
        ease: "power2.out",
        overwrite: true,
      });
    }

    changeEmpanadaColor(panels[0].dataset.color);

    panels.forEach((panel) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "top 50%",
        end: "bottom 50%",
        onToggle: (self) => {
          if (self.isActive) {
            changeEmpanadaColor(panel.dataset.color);
          }
        },
      });
    });

    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });
  }

  initEmpanadasScroll();
  // Disable GSAP on Mobile
  // Source: https://greensock.com/forums/topic/26325-disabling-scrolltrigger-on-mobile-with-mediamatch/
  ScrollTrigger.matchMedia({
    // Desktop Only Scrolltrigger
    "(min-width: 721px)": function () {}, // End Desktop Only Scrolltrigger
    // Mobile Only Scrolltrigger
    "(max-width: 720px)": function () {}, // End Mobile Only Scrolltrigger
    // 4k Only Scrolltrigger
    "(min-width: 2560px)": function () {}, // End Mobile Only Scrolltrigger
  }); // End GSAP Matchmedia

  if ($(".anim-container").length) {
    gsap.utils.toArray(".anim-container").forEach((container) => {
      // 1. Buscamos y validamos los elementos estándar (.anim-item) EN ESTE contenedor
      const animItems = container.querySelectorAll(".anim-item");
      if (animItems.length > 0) {
        gsap.from(animItems, {
          y: 120,
          duration: 1.25,
          opacity: 0,
          scrollTrigger: {
            trigger: container,
            start: "top 45%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
          },
          ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.25,
          },
        });
      }
      const animItemsLinea = container.querySelectorAll(".linea-titulo");
      if (animItemsLinea.length > 0) {
        gsap.from(animItemsLinea, {
          width: "0%",
          duration: 1,
          scrollTrigger: {
            trigger: container,
            start: "top 45%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
            //markers: true
          },
          // ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.75,
          },
        });
      }
      // 2. Buscamos y validamos los elementos no-scroll (.anim-item-ns) EN ESTE contenedor
      const animItemsNs = container.querySelectorAll(".anim-item-ns");
      if (animItemsNs.length > 0) {
        gsap.from(animItemsNs, {
          y: 120,
          duration: 1.25,
          opacity: 0,
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            end: "bottom 25%",
            toggleActions: "play none none none",
            once: true,
          },
          ease: "Expo.easeOut",
          stagger: {
            from: "start",
            amount: 0.25,
          },
        });
      }
    });
  }

  if ($(".split-line").length) {
    const splitPArray = gsap.utils.toArray(".split-line");
    document.fonts.ready.then(function () {
      splitPArray.forEach((P) => {
        const splitP = new SplitText(P, {
          type: ["lines"],
        });
        const splitPParent = new SplitText(P, {
          type: ["lines"],
          linesClass: "lineParent",
        });
        gsap.set(".lineParent", {
          overflow: "hidden",
        });
        const hasFooClass = P.classList.contains("foo");
        gsap.from(splitP.lines, {
          yPercent: 125,
          stagger: 0.1,
          scrollTrigger: {
            trigger: splitP.lines,
            start: hasFooClass ? "top 99%" : "top 80%",
          },
        });
      });
    });
  }
  if ($(".split-line-container").length) {
    const splitPArray = gsap.utils.toArray(
      ".split-line-container p, .split-line-container h1, .split-line-container h2, .split-line-container h3, .split-line-container h4,   .split-line-container ul li",
    );

    document.fonts.ready.then(() => {
      setTimeout(() => {
        const isMobile = window.innerWidth < 1024; // Ajusta el breakpoint si lo necesitas

        splitPArray.forEach((P) => {
          if (!P.textContent.trim()) return;

          // En mobile, reemplazamos los <br> por un espacio para que SplitText los ignore
          if (isMobile) {
            P.querySelectorAll("br").forEach((br) => {
              br.replaceWith(" ");
            });
          }

          const splitP = new SplitText(P, {
            type: "lines",
          });
          const splitPParent = new SplitText(P, {
            type: "lines",
            linesClass: "lineParent",
          });

          gsap.set(P.querySelectorAll(".lineParent"), {
            overflow: "hidden",
          });

          const hasFooClass = P.closest(
            ".split-line-container",
          ).classList.contains("foo");

          gsap.from(splitP.lines, {
            yPercent: 125,
            stagger: 0.1,
            scrollTrigger: {
              trigger: P,
              start: hasFooClass ? "top 99%" : "top 80%",
            },
          });
        });
      }, 50);
    });
  }

  // Images parallax
  /**/
  if ($(".img-p-container").length) {
    gsap.utils.toArray(".img-p-container").forEach((container) => {
      const img = container.querySelector("img");
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
        },
      });
      tl.fromTo(
        img,
        {
          yPercent: -7,
          ease: "none",
        },
        {
          yPercent: 7,
          ease: "none",
        },
      );
    });
  }
  //////////////////
  if ($(".reveal-img").length) {
    let revealContainers = document.querySelectorAll(".reveal-img");
    revealContainers.forEach((container) => {
      let image = container.querySelector("img");
      let t1 = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          // markers:true,
          start: "top 175%",
          end: "100% 0%",
        },
      });
      t1.set(container, {
        autoAlpha: 1,
      });
      t1.from(container, 1, {
        yPercent: 100,
        ease: Power2.out,
      });
      t1.from(image, 1, {
        yPercent: 0,
        scale: 1.2,
        delay: -1,
        ease: Power2.out,
      });
    });
  }
  ///////////////////////////////
  if ($(".reveal").length) {
    let revealLi = gsap.utils.toArray(".reveal");
    revealLi.forEach((wrapreveal) => {
      const image = wrapreveal.querySelector(".reveal>div,.reveal>a"),
        tl = gsap.timeline({
          paused: true,
        });
      tl.set(image, {
        autoAlpha: 1,
      });
      tl.from(wrapreveal, 1, {
        yPercent: 0,
        ease: "power2",
        clearProps: true,
      });
      tl.from(image, 1, {
        yPercent: 300,
        scale: 1.3,
        delay: -1,
        ease: "power2",
        //clearProps: true
      });
      wrapreveal.animation = tl; // record it on each element so we can reference the timeline later
    });
    ScrollTrigger.batch(revealLi, {
      onEnter: (elements) =>
        elements.forEach((e, i) => e.animation.delay(i * 0.1).restart(true)),
      once: true,
    });
  }
}
